let designations = [
  'A.A.',
  'A.A.&Q.M.G.',
  'A.A.A',
  'A.A.A.',
  'A.A.G.',
  'A.A.O.N.M.S.',
  'A.B.',
  'A.B.C.',
  'A.C.',
  'A.C.A.',
  'A.C.B.A.',
  'A.C.C.O.',
  'A.C.D.',
  'A.C.I.S.',
  'A.C.P.',
  'A.C.T.R.A.',
  'A.D.C.',
  'A.D.M.S.',
  'A.F.&A.M.',
  'A.F.C.',
  'A.F.L.',
  'A.F.M.',
  'A.F.P.',
  'A.F.T.R.A.',
  'A.I.A.',
  'A.I.A.',
  'A.I.C.B.',
  'A.I.C.E.',
  'A.I.Ch.E.',
  'A.I.I.A.',
  'A.I.I.C.',
  'A.I.M.E.',
  'A.I.S.A.',
  'A.L.A.',
  'A.L.H.C.',
  'A.M.',
  'A.M.C.',
  'A.M.C.T.',
  'A.M.P.',
  'A.Mus.',
  'A.O.C.',
  'A.O.C.A.',
  'A.O.C.A.D.',
  'A.O.C.-in-C.',
  'A.O.E.',
  'A.P.E.O.',
  'A.P.R.',
  'A.Q.M.G.',
  'A.R.A.',
  'A.R.A.M.',
  'A.R.C.A.',
  'A.R.C.C.O.',
  'A.R.C.O.',
  'A.R.C.S.',
  'A.R.C.T.',
  'A.R.I.B.A.',
  'A.R.S.M.',
  'A.S.A.',
  'A.S.C.',
  'A.S.H.R.A.E.',
  'A.S.L.A.',
  'A.T.C.M.',
  'A.U.C.C.',
  'A.V.C.M.',
  'A/V/M',
  'Acad.',
  'Acc.FM.',
  'ACCME',
  'ACCUTE',
  'Adeund.',
  'Ad.E.',
  'Adjt.',
  'Adm.',
  'Admin.',
  'Adv.Dip.Sw',
  'Ag.del’U.(Paris)',
  'Ag.dePhil.',
  'Agron.',
  'Alta.',
  'Anat.',
  'AOAIEA',
  'Art.Dip.Mus.',
  'Arty.',
  'ASL',
  'Atty.',
  'b.',
  'B.A.',
  'B.A.&Sc.',
  'B.A.(Ph.)',
  'B.A.A.',
  'B.A.Econ.',
  'B.A.Ed.',
  'B.A.O.',
  'B.A.P.',
  'B.A.R.',
  'B.A.S.',
  'B.A.Sc.',
  'B.Arch.',
  'B.ArtsSc.',
  'B.B.A.',
  'B.B.C.',
  'B.B.M.',
  'B.Bibl.',
  'B.C.',
  'B.C.D.',
  'B.C.E.',
  'B.C.L.',
  'B.C.S.',
  'B.Ch.,B.Chir.',
  'B.Ch.E.',
  'B.Chr.Ed.',
  'B.Com.,B.Comm.',
  'B.D.',
  'B.D.C.',
  'B.D.S.',
  'B.Des.',
  'B.Div.',
  'B.E.',
  'B.E.D.S.',
  'B.E.E.',
  'B.E.F.',
  'B.E.P.',
  'B.E.S.',
  'B.E.Sc.',
  'B.Ec.',
  'B.Ed.',
  'B.enPh.',
  'B.enSc.Com.',
  'B.Eng.',
  'B.èsA.',
  'B.èsL.',
  'B.èsSc.',
  'B.èsSc.App.',
  'B.F.',
  'B.F.A.',
  'B.G.S.',
  'B.H.E.',
  'B.H.K.',
  'B.H.Sc.',
  'B.I.D.',
  'B.I.S.',
  'B.J.',
  'B.J.C.',
  'B.L.',
  'B.L.A.',
  'B.L.S.',
  'B.Litt.',
  'B.M.',
  'B.M.E.',
  'B.M.V.',
  'B.Math.',
  'B.Mgmt.',
  'B.Mus.',
  'B.N.',
  'B.N.A.',
  'B.P.A.',
  'B.P.E.',
  'B.P.H.E.',
  'B.P.R.',
  'B.Paed.,B.Péd.',
  'B.Ph.',
  'B.Q.',
  'B.R.E.',
  'B.S.',
  'B.S.A.,B.Sc.A.',
  'B.S.B.A.',
  'B.S.C.E.',
  'B.S.E.E.,B.Sc.E.E.',
  'B.S.Ed.,B.S.E.',
  'B.S.F.',
  'B.S.M.E.',
  'B.S.N.',
  'B.S.P.',
  'B.S.S.',
  'B.S.T.',
  'B.S.W.',
  'B.Sc.',
  'B.Sc.A.',
  'B.Sc.Agr.',
  'B.Sc.Com.',
  'B.Sc.D.',
  'B.Sc.Eng.',
  'B.Sc.F.,B.S.F.',
  'B.Sc.Kin.',
  'B.Sc.N.,B.S.N.',
  'B.Sc.Phm.',
  'B.Sc.Soc.',
  'B.Soc.Sc.',
  'B.T.',
  'B.T.,B.Th.',
  'B.Tech.',
  'B.V.A.',
  'B.V.Sc.',
  'B.W.I.',
  'Bacc.',
  'Barr.',
  'Bart.',
  'Batty.',
  'Bgde.',
  'Bn.',
  'Bot.',
  'Brig.',
  'Brig.-Gen.',
  'Bt.',
  'by-el.',
  '(C)',
  'C.inC.',
  'C.ofC.',
  'C.ofE.',
  'C.A.',
  'C.A.A.',
  'C.A.A.A.',
  'C.A.A.P.',
  'C.A.C.E.',
  'C.A.D.C.',
  'C.A.E.',
  'C.A.F.A.D.',
  'C.A.M.C.',
  'C.A.P.',
  'C.A.P.C.',
  'C.A.S.C.',
  'C.A.S.W.',
  'C.A.T.M.',
  'C.A.U.T.',
  'C.B.',
  'C.B.C.',
  'C.B.C.P.',
  'C.B.E.',
  'C.B.S.E.',
  'C.B.V.',
  'C.Biol.',
  'C.C.',
  'C.C.E.',
  'C.C.F.P.',
  'C.C.H.S.E.',
  'C.C.L.',
  'C.C.O.',
  'C.Cri.',
  'C.D.',
  'C.Dir.',
  'C.E.',
  'C.E.C.',
  'C.E.F.',
  'C.E.N.',
  'C.E.O.',
  'C.E.R.A.',
  'C.E.S.',
  'C.E.S.A.',
  'C.E.S.O.',
  'C.Eng.',
  'C.F.A.',
  'C.F.E.',
  'C.F.L.',
  'C.F.O.',
  'C.F.P.',
  'C.F.R.E.',
  'C.G.A.',
  'C.G.F.M.',
  'C.H.',
  'C.H.A.',
  'C.H.E.',
  'C.H.F.C.,Ch.F.C.',
  'C.H.R.P.',
  'C.I.A.',
  'C.I.A.R.',
  'C.I.B.',
  'C.I.C.',
  'C.I.C.A.',
  'C.I.D.A.',
  'C.I.F.',
  'C.I.H.R.',
  'C.I.L.T.',
  'C.I.M.',
  'C.I.O.',
  'C.I.P.',
  'C.I.S.A.',
  'C.I.T.P.',
  'C.J.G.C.',
  'C.L.A.',
  'C.L.C.',
  'C.L.J.',
  'C.L.U.',
  'C.M.',
  'C.M.A.',
  'C.M.C.',
  'C.M.G.',
  'C.M.H.C.',
  'C.M.M.',
  'C.M.O.S.',
  'C.M.R.P.',
  'C.N.I.B.',
  'C.N.R.',
  'C.O.',
  'C.O.F.',
  'C.O.M.',
  'C.O.O.',
  'C.O.T.C.',
  'C.P.',
  'C.P.A.',
  'C.P.C.',
  'C.P.H.',
  'C.P.I.',
  'C.P.R.',
  'C.P.S.M.',
  'C.Psych.',
  'C.Q.',
  'C.R.',
  'C.R.A.',
  'C.R.M.',
  'C.R.S.P.',
  'C.R.T.C.',
  'C.S.C.,c.s.c.',
  'C.S.C.E.',
  'C.S.I.',
  'C.S.O.',
  'C.S.P.',
  'C.S.P.Q.',
  'C.S.P.W.C.',
  'C.S.R.',
  'C.St.J.',
  'C.T.C.',
  'C.T.F.',
  'C.U.P.E.',
  'C.U.S.O.',
  'C.V.O.',
  'C.V.S.M.',
  'CANSCAIP',
  'CAPAC',
  'CARAS',
  'CARFAC',
  'CCLP',
  'Cer.E.',
  'Cert.',
  'Ch.B.',
  'Ch.M.',
  'Chev.',
  'Chim.',
  'Chirurg.',
  'Chrmn.',
  'Cie.',
  'CIPP/C',
  'Clin.',
  'Clk.',
  'Co.',
  'Coll.',
  'Cons.',
  'Cpl.',
  'cr.',
  'Cytol.',
  'd.',
  'D.A.',
  'D.A.',
  'D.A.A.&Q.M.G.',
  'D.A.A.G.',
  'D.A.B.P.N.',
  'D.A.D.M.S.',
  'D.A.G.',
  'D.A.Q.M.G.',
  'D.A.Sc.',
  'D.Adm.',
  'D.Av.Med.',
  'D.B.A.',
  'D.C.',
  'D.C.H.',
  'D.C.L.',
  'D.C.M.',
  'D.C.S.',
  'D.C.T.',
  'D.Child.Psych.',
  'D.Cl.Chem.',
  'D.Cn.L.',
  'D.Comm.',
  'D.D.',
  'D.D.C.',
  'D.D.M.S.',
  'D.D.P.H.',
  'D.D.S.',
  'D.D.Sc.',
  'D.del’Un.',
  'D.E.A.',
  'D.E.C.',
  'D.E.S.',
  'D.E.S.S.',
  'D.Ed.',
  'D.enMéd.Vét.',
  'D.enPh.',
  'D.Eng.',
  'D.Env.Sts.',
  'D.èsA.',
  'D.èsL.',
  'D.F.A.',
  'D.F.C.',
  'D.F.S.',
  'D.F.Sc.',
  'D.G.M.',
  'D.Gén.',
  'D.H.',
  'D.H.L.',
  'D.Hum.L.,D.Hum.Litt.',
  'D.I.C.',
  'D.I.H.',
  'D.Ing.',
  'D.J.C.',
  'D.L.',
  'D.L.F.A.P.A.',
  'D.L.S.',
  'D.Lit.,D.Litt.',
  'D.Litt.S.',
  'D.M.',
  'D.M.A.',
  'D.M.D.',
  'D.M.R.',
  'D.M.S.',
  'D.Man.Sc.',
  'D.Mus.',
  'D.Mus.É.',
  'D.O.',
  'D.O.C.',
  'D.P.A.',
  'D.P.H.',
  'D.P.H.N.',
  'D.P.S.',
  'D.P.Sc.',
  'D.Paed.(Péd.)',
  'D.Ph.,D.Phil.',
  'D.Psych.',
  'D.S.A.',
  'D.S.C.',
  'D.S.E.F.',
  'D.S.L.',
  'D.S.O.',
  'D.S.S.',
  'D.S.W.',
  'D.Sc.',
  'D.Sc.Adm.',
  'D.Sc.C(om).',
  'D.Sc.Fin.',
  'D.Sc.Mil.',
  'D.Sc.Nat.',
  'D.Sc.P.',
  'D.Sc.Soc.',
  'D.St.J.',
  'D.Th.,D.Theol.',
  'D.U.',
  'D.Univ.(Paris)',
  'D.V.M.',
  'D.V.Sc.',
  'D-ABFDE',
  'dec’d.',
  'def.',
  'Dent.',
  'DGC',
  'D-I.I.F.E.S.',
  'Dip.Bus.Admin.',
  'Dip.C.S.',
  'Dip.Crim.',
  'Dip.Ed.',
  'Dip.L.A.T.',
  'Dip.Lsc.',
  'Dip.Operat.Perf.',
  'Dip.Psych.',
  'Dip.R.E.E.S.',
  'Dip.R.M.',
  'Dip.Tech.Ed.',
  'Dip.Trl.',
  'Doct.Arch.',
  'Dom.',
  'Dr.del’U.',
  'Dr.èsLettres',
  'Dr.Com.Sc.',
  'Dr.-Ing.',
  'Dr.jur.',
  'Dr.P.H.',
  'Dr.rer.nat.',
  'Dr.rer.pol.',
  'Drs.',
  'E.',
  'e.',
  'é.',
  'E.C.E.',
  'E.D.',
  'E.E.',
  'E.E.C.',
  'E.M.',
  'Ecol.',
  'Econ.',
  'Ed.D.',
  'Ed.M.',
  'el.',
  'ép.',
  'Epis.',
  'EPSRC',
  'ESSEC',
  'Ethnol.',
  'f.',
  'F.A.A.A.',
  'F.A.A.A.S.',
  'F.A.A.N.',
  'F.A.A.O.',
  'F.A.A.P.',
  'F.A.A.S.',
  'F.A.B.M.G.',
  'F.A.C.C.',
  'F.A.C.D.',
  'F.A.C.E.',
  'F.A.C.H.A.',
  'F.A.C.H.E.',
  'F.A.C.M.I.',
  'F.A.C.O.G.',
  'F.A.C.P.',
  'F.A.C.R.',
  'F.A.C.S.',
  'F.A.C.S.M.',
  'F.A.C.T.L.',
  'F.A.E.',
  'F.A.G.O.',
  'F.A.G.S.',
  'F.A.H.A.',
  'F.A.H.P.',
  'F.A.I.A.',
  'F.A.I.C.',
  'F.A.P.H.A.',
  'F.A.P.S.',
  'F.A.S.A.B.E.',
  'F.A.S.C.E.',
  'F.A.S.C.P.',
  'F.A.S.M.',
  'F.A.S.M.E.',
  'F.A.Z.R.A.',
  'F.AINA',
  'F.ASTM',
  'F.B.A.',
  'F.B.O.A.',
  'F.B.O.U.',
  'F.B.Ps.S.',
  'F.B.S.C.',
  'F.Brit.I.R.E.',
  'F.C.A.',
  'F.C.A.E.',
  'F.C.A.H.S.',
  'F.C.A.S.I.',
  'F.C.B.A.',
  'F.C.B.V.',
  'F.C.C.A.',
  'F.C.C.H.S.E.',
  'F.C.C.M.G.',
  'F.C.C.O.',
  'F.C.F.P.',
  'F.C.G.A.',
  'F.C.I.',
  'F.C.I.A.',
  'F.C.I.A.R.',
  'F.C.I.Arb.',
  'F.C.I.C.',
  'F.C.I.I.',
  'F.C.I.P.orFCIP',
  'F.C.I.S.',
  'F.C.M.A.',
  'F.C.N.R.S.',
  'F.C.P.A.',
  'F.C.S.',
  'F.C.S.A.',
  'F.C.S.B.E.',
  'F.C.S.C.E.',
  'F.C.S.I.',
  'F.C.S.L.A.',
  'F.C.S.M.E.',
  'F.C.S.S.E.',
  'F.CIFST',
  'F.E.',
  'F.E.C.S.',
  'F.E.I.C.',
  'F.E.S.',
  'F.E.S.C.',
  'F.F.A.',
  'F.F.P.S.',
  'F.F.R.',
  'F.G.A.',
  'F.G.D.C.',
  'F.G.S.',
  'F.G.S.A.',
  'F.H.S.C.',
  'F.I.A.',
  'F.I.A.B.S.',
  'F.I.A.Fo.S.T',
  'F.I.A.L.',
  'F.I.A.S.',
  'F.I.Ae.S.',
  'F.I.C.',
  'F.I.C.B.',
  'F.I.C.D.',
  'F.I.E.',
  'F.I.E.E.',
  'F.I.I.A.',
  'F.I.I.C.',
  'F.I.I.F.C.',
  'F.I.I.S.L.',
  'F.I.Inst.',
  'F.I.L.A.',
  'F.I.M.',
  'F.I.M.C.',
  'F.I.M.M.M.',
  'F.I.R.E.',
  'F.I.S.A.',
  'F.I.S.A.E.',
  'F.I.T.',
  'F.Inst.P.',
  'F.Inst.Pet.',
  'F.ISHMII.',
  'F.L.A.',
  'F.L.C.M.',
  'F.L.M.I.',
  'F.L.S.',
  'F.M.S.A.',
  'F.N.A.',
  'F.N.A.A.S.',
  'F.N.C.M.',
  'F.N.F.C.F.',
  'F.P.S.',
  'F.Phys.S.',
  'F.R.A.I.',
  'F.R.A.I.C.',
  'F.R.A.M.',
  'F.R.A.S.',
  'F.R.Ae.S.',
  'F.R.B.S.',
  'F.R.C.C.O.',
  'F.R.C.D.(C)',
  'F.R.C.M.',
  'F.R.C.O.',
  'F.R.C.O.G.',
  'F.R.C.P.',
  'F.R.C.S.',
  'F.R.C.S.(C)',
  'F.R.C.V.S.',
  'F.R.E.S.',
  'F.R.G.D.',
  'F.R.G.S.',
  'F.R.G.S.(C)',
  'F.R.H.S.C.',
  'F.R.Hist.S.,F.R.H.S.',
  'F.R.Hort.S.',
  'F.R.I.B.A.',
  'F.R.I.C.',
  'F.R.I.C.S.',
  'F.R.I.P.H.H.',
  'F.R.M.S.',
  'F.R.Met.S.',
  'F.R.N.S.',
  'F.R.P.S.L.',
  'F.R.S.',
  'F.R.S.',
  'F.R.S.A.',
  'F.R.S.C.',
  'F.R.S.C.,F.R.S.Chem.',
  'F.R.S.E.',
  'F.R.S.H.',
  'F.R.S.L.',
  'F.R.S.M.',
  'F.R.S.T.M.&H.',
  'F.S.A.',
  'F.S.A.A.',
  'F.S.B.',
  'F.S.E.',
  'F.S.M.A.C.',
  'F.S.P.I.E.',
  'F.S.S.',
  'F.T.C.L.',
  'F.Z.S.',
  'FCAOT',
  'FEC',
  'FFSSoc.',
  'FGC',
  'FIIE',
  'FISEAM',
  'FNASc.',
  'FRCPC,F.R.C.P.(C)',
  'FSSocDip.',
  'G.B.E.',
  'G.C.',
  'G.C.F.C.',
  'G.C.I.E.',
  'G.C.M.G.',
  'G.C.S.I.',
  'G.C.St.J.',
  'G.C.V.O.',
  'G.D.P.A.',
  'g.e.',
  'G.H.Q.',
  'G.J.',
  'G.M.',
  'G.O.C.',
  'G.O.Q.',
  'G.S.O.',
  'Gaz.',
  'Geneal.',
  'Geol.',
  'GM.P.I.P.S.C.',
  'H.B.A.',
  'HBSc',
  'h.c.',
  'H.E.',
  'H.E.C.',
  'Histol.',
  'H.M.',
  'H.M.C.S.',
  'H.M.S.',
  'H.O.',
  'H.ofC.',
  'Homoeo.',
  'Hon.',
  'Hons.',
  'Hortic.',
  'H.Q.',
  'H.R.H.',
  'Hts.',
  'I.C.A.O.',
  'I.E.E.E.',
  'I.I.S.D.',
  'I.L.O.',
  'I.O.D.E.',
  'I.O.F.',
  'I.O.O.F.',
  'I.P.C.',
  'I.S.O.',
  'I.S.P.',
  'i/c',
  'ICD.D',
  'Inf.',
  'Ing.',
  'ing.f.',
  'Ins.',
  'Inspr.',
  'Inst.',
  'Instr.',
  'Int.A.I.A.',
  'Invest.',
  'Investig.',
  'J.B.',
  'J.C.B.',
  'J.C.D.',
  'J.C.L.',
  'J.C.Q.',
  'J.D.',
  'J.D.S.',
  'J.P.',
  'J.S.D.',
  'J.U.L.',
  'JChLJ',
  'Jos.',
  'Jt.',
  'Jur.utr.Dr.',
  'K.ofC.',
  'K.B.E.',
  'K.C.',
  'K.C.B.',
  'K.C.H.S.',
  'K.C.L.J.',
  'K.C.M.G.',
  'K.C.S.G.',
  'K.C.S.I.',
  'K.C.V.O.',
  'K.G.',
  'K.H.S.',
  'K.J.G.C.',
  'K.L.J.',
  'K.St.J.',
  'K.T.',
  'Kt.',
  'L.Cdr.',
  'L.Ch.',
  'L.Col.',
  'L.D.C.',
  'L.D.S.',
  'L.Div.',
  'L.E.L.',
  'L.èsD.',
  'L.èsL.',
  'L.èsSc.',
  'L.G.S.M.',
  'L.Gen.',
  'L.J.C.',
  'L.M.C.C.',
  'L.M.C.H.(Cantab)',
  'L.Mus.',
  'L.O.L.',
  'l.p.',
  'L.P.N.',
  'L.Péd.',
  'L.Ph.',
  'L.Psych.',
  'L.R.A.M.',
  'L.R.C.P.',
  'L.R.C.S.',
  'L.R.C.T.',
  'L.R.C.V.S.',
  'L.R.H.S.C.',
  'L.R.S.M.',
  'L.S.',
  'L.S.A.',
  'L.S.Sc.',
  'L.Sc.Adm.',
  'L.Sc.Comm.',
  'L.Sc.O.',
  'L.Sc.Soc.',
  'L.T.C.L.',
  'L.T.C.M.',
  'L.Th.',
  'L.V.C.M.',
  'L.V.O.',
  'Ldr.',
  'LEEDAP',
  'LF.I.E.E.E.',
  'Lib.',
  'Lic.',
  'Lic.Med.',
  'Lit.hum.',
  'Litt.',
  'Litt.B.',
  'Litt.D.',
  'LL.B.',
  'LL.D.',
  'LL.L.',
  'LL.M.',
  'LSLSCert.AVT',
  'LSM',
  'Lt.',
  'm.',
  'M.A.',
  'M.A.A.A.',
  'M.A.C.P.',
  'M.A.C.S.S.    ',
  'M.A.I.',
  'M.A.I.B.C.',
  'M.A.L.D.',
  'M.A.L.S.',
  'M.A.O.',
  'M.A.Sc.',
  'M.A.T.',
  'M.Acc.',
  'M.Arch.',
  'M.B.',
  'M.B.A.',
  'M.B.B.S.',
  'M.B.E.',
  'M.C.',
  'M.C.E.',
  'M.C.G.I.',
  'M.C.I.',
  'M.C.I.Arb.',
  'M.C.I.C.',
  'M.C.I.PorMCIP',
  'M.C.L.',
  'M.C.P.',
  'M.C.Psyc',
  'M.C.S.',
  'M.Ch.,M.Chir.',
  'M.Cl.Sc.',
  'M.Com.,M.Comm.',
  'M.D.',
  'M.D.C.',
  'M.D.S.',
  'M.D.Y.',
  'M.Div.',
  'M.E.',
  'M.E.A.',
  'M.E.E.',
  'M.E.S.',
  'M.Ec.',
  'M.Ed.',
  'M.Eng.',
  'M.èsA.',
  'M.èsL.',
  'M.F.',
  'M.F.A.',
  'M.Fisc.',
  'M.H.A.',
  'M.H.C.M.',
  'M.H.K.',
  'M.H.L.',
  'M.H.Sc.',
  'M.I.Biol.',
  'M.I.P.P.',
  'M.I.S.',
  'M.I.St.',
  'M.I.T.',
  'M.Ind.R.,M.I.R.',
  'M.Inst.R.',
  'M.J.',
  'M.Kin.',
  'M.L.',
  'M.L.A.',
  'M.L.I.S.',
  'M.L.S.',
  'M.Leg.St.',
  'M.Litt.',
  'M.M.',
  'M.M.M.',
  'M.M.St.',
  'M.Mus.',
  'M.N.',
  'M.N.A.',
  'M.O.',
  'M.O.M.',
  'M.P.',
  'M.P.A.',
  'M.P.E.',
  'M.P.E.P.',
  'M.P.H.',
  'M.P.M.',
  'M.P.P.',
  'M.Ph.,M.Phil.',
  'M.PL.',
  'M.Ps.',
  'M.R.C.',
  'M.R.C.O.G.',
  'M.R.C.P.',
  'M.R.C.S.',
  'M.R.C.V.S.',
  'M.R.E.',
  'M.R.I.A.',
  'M.R.M.',
  'M.R.S.H.',
  'M.S.',
  'M.S.A.',
  'M.S.C.',
  'M.S.D.',
  'M.S.D.T.',
  'M.S.E.E.',
  'M.S.Ed.',
  'M.S.F.',
  'M.S.J.',
  'M.S.L.',
  'M.S.M.',
  'M.S.O.D.',
  'M.S.R.C.',
  'M.S.S.',
  'M.S.W.',
  'M.Sc.',
  'M.Sc.A.',
  'M.Sc.Ag.',
  'M.Sc.Com.',
  'M.Sc.F.,M.sc.for.',
  'M.Sc.N.,M.S.N.',
  'M.Sc.Phm.',
  'M.Sc.Pl.',
  'M.Sc.Soc.',
  'M.Soc.',
  'M.Tax.',
  'M.Trad.',
  'M.U.Dr.',
  'M.U.P.,M.Urb.',
  'M.V.A.',
  'M.V.O.',
  'MAA',
  'MAIB',
  'Man.',
  'Meth.',
  'Metrop.',
  'MIET',
  'Mil.',
  'MIMech.E.',
  'Min.',
  'Msgr.',
  'Mun.',
  'Mus.B(ac).',
  'Mus.B(ac).Perf.',
  'Mus.D(oc).',
  'Mus.M.',
  'Mycol.',
  'N.',
  'N.A.T.O.',
  'N.B.',
  'N.D.',
  'N.D.D.',
  'N.D.E.E.',
  'N.D.G.',
  'N.D.P.',
  'N.E.B.',
  'N.F.B.',
  'N.F.U.',
  'N.G.O.',
  'N.H.L.',
  'N.I.M.H.',
  'N.L.S.',
  'N.O.A.A.',
  'N.P.',
  'N.P.A.M.',
  'N.R.C.',
  'N.S.',
  'N.S.C.A.D.',
  'N.S.E.R.C.',
  'n.s.s.',
  'N.S.W.',
  'N.W.T.',
  'N.Z.',
  'ndc',
  'Neurol.',
  'Nfld.&Lab.',
  'No.',
  'Numis.',
  'o.',
  'O.A.A.',
  'O.A.Q.',
  'O.A.S.',
  'O.B.C.',
  'O.B.E.',
  'O.C.',
  'O.D.',
  'O.E.C.D.',
  'O.M.',
  'O.M.C.',
  'O.M.I.',
  'O.M.L.J.',
  'O.M.M.',
  'O.M.R.I.',
  'O.N.B.',
  'O.N.G.',
  'O.N.L.',
  'O.N.Q.',
  'O.N.S.',
  'O.O.M.',
  'O.Ont.',
  'O.P.E.I.',
  'O.Q.',
  'O.S.A.',
  'O.St.J.',
  'O.U.Q.',
  'Offr.',
  'Ont.',
  'Op.Dip.Perf.',
  'Ophthal(mol).',
  'OPM',
  'Orgn.',
  'Ornithol.',
  'OSPE',
  'OTReg.PE,',
  'Otol.',
  'P.Adm.',
  'P.Ag.',
  'P.C.',
  'P.C.J.',
  'p.c.s.c.',
  'P.Dt.',
  'P.E.I.',
  'P.E.N.',
  'P.E.O.',
  'P.Eng.',
  'P.G.C.E.',
  'P.Geo.',
  'P.M.',
  'P.M.P.',
  'P.O.W.',
  'P.P.C.L.I.',
  'p.s.',
  'p.s.a.',
  'p.s.c.',
  'Pac.',
  'Parliam.',
  'Parlty.',
  'Path(ol).',
  'PEBC',
  'Perm.',
  'PG.Dip',
  'Ph.B.',
  'Ph.C.',
  'Ph.D.',
  'Ph.L.',
  'Pharm.D.',
  'Phil.M.',
  'Philol.',
  'Philos.',
  'Phm.B.',
  'Phys.',
  'Physiol.',
  'Phytopath(ol).',
  'PLC,plc',
  'Pol.',
  'Polytech.',
  'Pomol.',
  'Prep.',
  'Pres.',
  'Presb.',
  'Presby.',
  'Prop.',
  'Prot.',
  'Psychol.',
  'Pte.',
  'PTY,pty',
  'Q.C.',
  'Q.H.S.',
  'Q.L.S.',
  'Q.M.',
  'Q.M.G.',
  'Q.O.R.',
  'Que.',
  'R.A.',
  'R.A.F.',
  'R.A.I.C.',
  'R.A.M.',
  'R.A.M.C.',
  'R.A.S.C.',
  'R.B.A.',
  'R.C.A.',
  'R.C.A.C.',
  'R.C.A.F.',
  'R.C.A.M.C.',
  'R.C.D.',
  'R.C.E.',
  'R.C.E.M.E.',
  'R.C.F.A.',
  'R.C.G.A.',
  'R.C.M.',
  'R.C.M.P.',
  'R.C.N.',
  'R.C.N.V.R.',
  'R.C.O.C.',
  'R.C.R.',
  'R.C.Y.C.',
  'R.E.',
  'R.F.A.',
  'R.F.C.',
  'R.F.P.',
  'R.I.A.',
  'R.I.B.',
  'R.M.C.',
  'R.N.',
  'R.N.S.Y.S.',
  'R.O.',
  'R.P.',
  'R.P.A.',
  'R.P.Bio.',
  'R.P.F.',
  'R.Ph.',
  'R.R.',
  'R.S.W.',
  'R22eR',
  'Regt.',
  'Res.',
  'Res.Dip.S.W.',
  'Rev.',
  'Rhinol.',
  'RI',
  'Röntgenol.',
  'Rt.',
  'S.',
  's.',
  'S.A.A.',
  'S.A.F.A.',
  'S.B.',
  'S.B.St.J.',
  'S.C.',
  'S.C.A.',
  'S.D.',
  'S.J.',
  'S.J.D.',
  'S.M.',
  'S.O.M.',
  'S.P.H.R.',
  'S.R.C.',
  'S.S.B.',
  'S.S.C.',
  'S.S.F.C.',
  'S.S.L.',
  'S.S.St.J.',
  'S.T.B.,S.Th.B.',
  'S.T.D.,S.Th.D.',
  'S.T.L.,S.Th.L.',
  'S.T.M.',
  'S.V.M.',
  'Sask.',
  'Sc.D.',
  'Sc.L.',
  'Sc.Soc.B.',
  'Sc.Soc.D.',
  'Sc.Soc.L.',
  'Sec.',
  'Sém.',
  'Semy.',
  'Soc.',
  'SOCAN',
  'Sociol.',
  'SODRAC',
  'Solr.',
  'Sqdn.',
  'Sr.',
  'SSHRCC',
  'Stat.',
  'T.E.P.',
  'T.E.S.L.',
  'Th.B.',
  'Th.D.',
  'Theol.',
  'Th.L.',
  'Topog.',
  'Toxicol.',
  'Twp.',
  'U.A.A.C.',
  'U.E.,U.E.L.',
  'U.K.',
  'U.M.W.A.',
  'U.N.',
  'U.N.S.M.(Korea)',
  'U.O.M.',
  'U.S.N.',
  'Un.',
  'UNESCO',
  'UNICEF',
  'UNO',
  'UNRRA',
  'Urol.',
  'V.C.',
  'V.D.',
  'Ven.',
  'VeryRev.',
  'Vet.',
  'V.G.',
  'Vol.',
  'V.Q.M.G.',
  'V.R.D.',
  'V.S.',
  'W.',
  'W.H.O.',
  'W.I.P.O.',
  'W.P.T.B.',
  'W.T.O.',
  'Y.M.C.A.',
  'Y.M.H.A.',
  'Y.W.C.A.',
  'Y.W.H.A.',
]

export default designations



// WEBPACK FOOTER //
// ./src/shared/designations.js